// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pa-c";
export var backButton = "_pa-4";
export var backIcon = "_pa-5";
export var chevronShortcut = "_pa-6";
export var container = "_pa-1";
export var editor = "_pa-8";
export var editorWrapper = "_pa-7";
export var prefix = "_pa-2";
export var searchIcon = "_pa-3";
export var suffix = "_pa-9";
export var suffixContent = "_pa-a";
export var suffixText = "_pa-b";
export var wrapper = "_pa-0";